/*
 * Copyright (c) 2008-2020 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
 * This is CONFIDENTIAL code. Use is subject to license terms.
 */

/**
 * create and manage client info object
 *
 * most of this is taken from MeetingManagement.js
 */

import { getStorageObject } from "../utils/Storage"
import { v4 as UUIDv4 } from "uuid"
// todo maybe import config here?

let clientType = "Browser"
let stationType = ""

function getInterfaceType() {
  if (navigator && navigator.connection && navigator.connection.type) {
    return navigator.connection.type
  }
  return "-"
}

const clientInfo = {
  clientOS: navigator.platform,
  clientVM: navigator.userAgent,
  clientVersion: "${build.number}",
  wrapperVersion: "", //+ Wrapper.wrapperVersion,
  clientType: clientType,
  clientDeviceName: "Browser", // todo check if used somewhere ...
  clientIPAddress: "",
  deviceId: "",
  stationType: stationType,
  locale: "", // todo maybe provide the locale stored in local storage ... se MAB's stuff ...
  connectionId: "CC-" + UUIDv4(), // Prefix for MCC clients (DEV-1911)
  previousConnectionId: getStorageObject("previousConnectionId", ""),
  userId: getStorageObject("userId"),
  meetingId: "",
  clientUpdateType: "WS", // todo make this configurable
  interfaceType: getInterfaceType(),
}
export default clientInfo
